if (!customElements.get("input-phone")) {
  function getBrowserLocales(options = {}) {
    const defaultOptions = {
      languageCodeOnly: false,
    };

    const opt = {
      ...defaultOptions,
      ...options,
    };

    const browserLocales =
      navigator.languages === undefined
        ? [navigator.language]
        : navigator.languages;

    if (!browserLocales) {
      return undefined;
    }

    return browserLocales.map((locale) => {
      const trimmedLocale = locale.trim();

      return opt.languageCodeOnly
        ? trimmedLocale.split(/-|_/)[0]
        : trimmedLocale;
    });
  }
  class InputPhone extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector("input");
      this.hiddenInput = this.querySelector('input[type="hidden"]');
      this.userPrefLocales = getBrowserLocales();
      this.errorElement = null;
      this.wrapperElement = null;
    }
    connectedCallback() {
      let currentLocale = 'auto';
      if (this.userPrefLocales && this.userPrefLocales.length > 0) {
        const localeParts = this.userPrefLocales[0].split("-");
        currentLocale = localeParts.length > 1 && localeParts[1] ? localeParts[1] : (localeParts[0] || 'auto');
      }

      this.iti = window.intlTelInput(this.input, {
        utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@24.5.0/build/js/utils.js",
        autoPlaceholder: "off",
        initialCountry: currentLocale ? currentLocale : "auto"
      });

      // Find error element and wrapper
      this.wrapperElement = this.closest('.mdc-text-field, .phone-register');
      if (this.wrapperElement) {
        this.errorElement = this.wrapperElement.querySelector('[data-phone-error]');
      }

      this.input.addEventListener("change", () => this.setHiddenInputValue());
      this.input.addEventListener("keyup", () => this.setHiddenInputValue());
      this.input.addEventListener("blur", () => this.validate());
      this.input.addEventListener("countrychange", () => this.validate());
    }

    setHiddenInputValue() {
      if (this.iti.isValidNumber()) {
        this.hiddenInput.value = this.iti.getNumber();
      } else {
        this.hiddenInput.value = "";
      }
    }

    validate() {
      if (!this.errorElement || !this.wrapperElement) return true;

      const phoneValue = this.input.value.trim();

      // If phone is empty, it's valid (optional field)
      if (phoneValue === '') {
        this.clearError();
        return true;
      }

      const isValid = this.iti.isValidNumber();

      if (!isValid) {
        const errorCode = this.iti.getValidationError();
        const errorMsg = this.getErrorMessage(errorCode);
        this.showError(errorMsg);
        return false;
      } else {
        this.clearError();
        return true;
      }
    }

    getErrorMessage(errorCode) {
      // Get error messages from data attributes
      const messages = {
        default: this.dataset.errorInvalid || 'Please enter a valid phone number',
        1: this.dataset.errorInvalidCountry || 'Invalid country code',
        2: this.dataset.errorTooShort || 'Phone number is too short',
        3: this.dataset.errorTooLong || 'Phone number is too long',
        4: this.dataset.errorNotValid || 'Please enter only numbers'
      };

      return messages[errorCode] || messages.default;
    }

    showError(message) {
      if (this.errorElement) {
        this.errorElement.textContent = message;
        this.errorElement.style.display = 'block';
      }
      if (this.wrapperElement) {
        this.wrapperElement.classList.add('mdc-text-field--invalid');
      }
    }

    clearError() {
      if (this.errorElement) {
        this.errorElement.style.display = 'none';
      }
      if (this.wrapperElement) {
        this.wrapperElement.classList.remove('mdc-text-field--invalid');
      }
    }
  }
  customElements.define("input-phone", InputPhone);
}
